import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EnrollmentDetailsContent } from "../../programs/EnrollmentDetailsContent";

interface ViewEnrollmentDialogProps {
  open: boolean;
  enrollment: any;
  coaches: any[];
  onClose: () => void;
}

export const ViewEnrollmentDialog = ({ open, enrollment, coaches, onClose }: ViewEnrollmentDialogProps) => {
  if (!enrollment) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle component="div" sx={{ pb: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={700} component="div">
            Enrollment Details
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={3}>
          <EnrollmentDetailsContent enrollment={enrollment} />

          <Box>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom color="primary">
              Coach Information
            </Typography>
            <Paper variant="outlined" sx={{ p: 2, backgroundColor: "#fafafa" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Program Coach</Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {enrollment.session?.program?.programCoach === null
                        ? "Unassigned"
                        : `${enrollment.session?.program?.programCoach?.firstName || ""} ${enrollment.session?.program?.programCoach?.lastName || ""}`.trim() ||
                          enrollment.session?.program?.programCoach?.email ||
                          "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Session Coach</Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {enrollment.session?.sessionCoachOrEmployee === null
                        ? "Unassigned"
                        : `${enrollment.session?.sessionCoachOrEmployee?.firstName || ""} ${enrollment.session?.sessionCoachOrEmployee?.lastName || ""}`.trim() ||
                          enrollment.session?.sessionCoachOrEmployee?.email ||
                          "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Enrollment Coach</Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {Array.isArray(enrollment.coachIds) && enrollment.coachIds.length > 0
                        ? `${coaches.find((c) => c.id === enrollment.coachIds[0])?.firstName || ""} ${coaches.find((c) => c.id === enrollment.coachIds[0])?.lastName || ""}`.trim() ||
                          coaches.find((c) => c.id === enrollment.coachIds[0])?.email ||
                          "Unassigned"
                        : "Unassigned"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Button onClick={onClose} sx={{ borderRadius: 2 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
